import _debounce from "lodash/debounce";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "semantic-ui-react";

import { setExactMonitoringStatusCodeFilter, useExactMonitoringFilters } from "modules/ExactMonitoring/components/ApiErrors/hooks";

import type { ChangeEvent } from "react";
import type { InputOnChangeData } from "semantic-ui-react";

const DEBOUNCE_TIME = 500;

export const StatusCodeFilter = () => {
  const { t } = useTranslation();

  const { status_code } = useExactMonitoringFilters();
  const [statusCode, setStatusCode] = useState(status_code);
  const debouncedSetStatusCodeFilter = useMemo(() => _debounce(setExactMonitoringStatusCodeFilter, DEBOUNCE_TIME), []);

  const handleStatusCodeChange = (_e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    const newStatusCode = data.value ? Number(data.value) : null;

    setStatusCode(newStatusCode);
    debouncedSetStatusCodeFilter(newStatusCode);
  };

  return <Input fluid type="number" value={statusCode ?? ""} onChange={handleStatusCodeChange} placeholder={t("v8_enter_status_code", "Enter status code")} />;
};
